<body class="ltr main-body leftmenu">
    <form autocomplete="off" novalidate>
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="row row-sm add-form">
                        <form autocomplete="off" class="p-0" novalidate [formGroup]="centerAlloForm">
                            <div class="col-lg-12 col-md-12">
                                <div class="card custom-card">
                                    <div class="card-body">
                                        <div class=" d-flex align-items-center pl-3">
                                            <img alt="Logo" src="../../assets/img/CollegeMaster.png"
                                                class="mh-45px pb-2">
                                            <div>
                                                <h3 class="main-content-label mb-1"><b>
                                                        Center Allocation
                                                    </b></h3>
                                                <p class="text-muted card-sub-title mb-0">
                                                    Center Allocation
                                                </p>
                                            </div>
                                        </div>
                                        <hr class="mb-2 mt-1">
                                        <div class="row clearfix mt-3">
                                            <!-- Session Dropdown -->
                                            <div class="col-sm-4">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label>Session</mat-label>
                                                            <mat-select #selectSession class="colorblack"
                                                                        formControlName="SessionId"
                                                                        (selectionChange)="onSessionChange($event.value)"
                                                                        required>
                                                                <mat-select-filter *ngIf="selectSession.focused"
                                                                                   [placeholder]="'Filter'"
                                                                                   [displayMember]="'SnName'"
                                                                                   [array]="sessionList"
                                                                                   (filteredReturn)="filteredSessionList = $event">
                                                                </mat-select-filter>
                                                                <mat-option *ngFor="let item of filteredSessionList"
                                                                            [value]="item.SnNo">
                                                                    {{ item.SnName }}
                                                                </mat-option>
                                                            </mat-select>
                                                            <mat-error class="margin_tp"
                                                                *ngIf="centerAlloForm.controls['SessionId'].touched && centerAlloForm.controls['SessionId'].errors?.required">
                                                                Mandatory
                                                            </mat-error>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Existing List dropdown -->
                                            <div class="col-sm-4">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label> List</mat-label>
                                                            <mat-select formControlName="listNo" #select23 required
                                                                class="colorblack">
                                                                <mat-select-filter *ngIf="select23.focused"
                                                                    [placeholder]="'Filter'"
                                                                    [displayMember]="'ListDesc'" [array]="DataList"
                                                                    (filteredReturn)=" filteredDataList =$event"></mat-select-filter>
                                                                <mat-option *ngFor="let item of  filteredDataList"
                                                                    [value]="item.EcId"
                                                                    (click)="getGridData(item.EcId)">
                                                                    {{item.ListDesc}}
                                                                </mat-option>
                                                            </mat-select>
                                                            <mat-error class="margin_tp"
                                                                *ngIf="centerAlloForm.controls['listNo'].touched && centerAlloForm.controls['listNo'].errors?.required">
                                                                Mandatory
                                                            </mat-error>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> Valid</mat-label>
                                                        <mat-select formControlName="Valid" #select104
                                                            class="colorblack">
                                                            <mat-option>Select</mat-option>
                                                            <mat-option value="N">No</mat-option>
                                                            <mat-option value="Y">Yes</mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> Changed</mat-label>
                                                        <mat-select formControlName="Chng" readonly #select104
                                                            class="colorblack">
                                                            <mat-option>Select</mat-option>
                                                            <mat-option value="N">No</mat-option>
                                                            <mat-option value="Y">Yes</mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <hr>
                                        <div class="row clearfix" *ngIf="show">
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label>College Code </mat-label>
                                                            <input matInput formControlName="CaCgCode" readonly
                                                                placeholder="College Code">
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-5">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label> College Name </mat-label>
                                                            <input matInput formControlName="CgName" readonly
                                                                placeholder="College Name">
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                             <div class="col-sm-2">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label> District</mat-label>
                                                            <input readonly matInput formControlName="DsName"
                                                                placeholder="DsName">
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label> Candidates</mat-label>
                                                            <input readonly matInput formControlName="CaCand"
                                                                placeholder="Candidates">
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label> Center</mat-label>
                                                            <input readonly matInput formControlName="CaCent" placeholder="">
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-6">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label>Center College Name</mat-label>

                                                            <mat-select required formControlName="CnName" #select23
                                                                class="colorblack">
                                                                <mat-select-filter *ngIf="select23.focused"
                                                                    [placeholder]="'Filter'" [displayMember]="'CgName'"
                                                                    [array]="CenterData"
                                                                    (filteredReturn)=" filteredCenterData =$event"></mat-select-filter>
                                                                <mat-option *ngFor="let item of  filteredCenterData"
                                                                    [value]="item.CgName" (click)="getCenterData(item)">
                                                                    {{item.CgName}}
                                                                </mat-option>
                                                            </mat-select>
                                                            <mat-error class="margin_tp err"
                                                            *ngIf="centerAlloForm.controls['CnName'].touched && centerAlloForm.controls['CnName'].errors?.required">
                                                           Mandatory
                                                        </mat-error>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label> Allocate</mat-label>
                                                            <input readonly matInput formControlName="CaAllo" (input)="onInputChange($event)"
                                                                placeholder="Allocated">
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-sm-2" *ngIf="cap">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label> Capacity</mat-label>
                                                            <input matInput [value]="capacity ? capacity : 0" readonly=""
                                                                placeholder="Capacity">
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-8 pri-0"></div>
                                            <div class="col-sm-2 pri-0">
                                                <button type="button"
                                                    class="btn wd btn-primary btn-icon-text floatright mt-1"
                                                    (click)="update()" [disabled]="updateDisabled">
                                                    <span style="display: contents; align-items: center;">
                                                        <img width="20vh" src="../../assets/img/edit1.gif"
                                                            style="margin-right: 5px;">
                                                        Update
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div *ngIf="Table" class="col-sm-12 pl-0">
                                        <div>
                                            <div class="table-responsive table-container" id="table">
                                                <table class="table table-bordered text-nowrap">
                                                    <thead>
                                                        <tr class="text-left">
                                                            <th class="f600">
                                                                Sr.No
                                                            </th>
                                                            <th class="f600">
                                                                T/A
                                                            </th>
                                                            <!-- <th class="f600">
                                                                College Code
                                                            </th> -->
                                                            <th class="f600">
                                                                College Name
                                                            </th>
                                                            <th class="f600">
                                                                District
                                                            </th>
                                                            <th class="f600">
                                                               Assigned Center Name
                                                            </th>
                                                            
                                                            <th class="f600">
                                                                Candidates
                                                            </th>
                                                            <th class="f600">
                                                                Center
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr *ngFor="let data of DataList1; let i = index;" height="20%"
                                                            (click)="edit('true',data)">
                                                            <td>{{i + 1}}</td>
                                                            <td>{{ data.CaType === 'A' ? 'Allocated' : (data.CaType === 'T' ? 'Total' : '') }}</td>
                                                            <!-- <td>{{data.CaCgCode}}</td> -->
                                                            <td>{{data.CaCgCode}} - {{data.CgName}}</td>
                                                            <td>{{data.DsName}}</td>
                                                            <td>{{data.CnName}}</td>
                                                            <td>{{data.CaCand}}</td>
                                                            <td>{{data.CaAllo}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <hr>
                                            </div>
                                        </div>
                                    </div>

                                </div>


                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>